import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/pirate_subscribe.png")